// extracted by mini-css-extract-plugin
module.exports = {"footer":"UploaderSubmit_footer__I4591"};